import { ScrollableContext } from "@/components/Scrollable/ScrollableContext.ts"

import type { ScrollableModel } from "@/components/Scrollable/ScrollableModel.ts"
import type { PropsWithChildren } from "react"


type ScrollableModelProps = PropsWithChildren & {
  model: ScrollableModel
}

export const ScrollableModelProvider = (props: ScrollableModelProps) => {
  return <ScrollableContext value={props.model}>{props.children}</ScrollableContext>
}